export const SECOND = 1000;
export const MINUTE = 60 * SECOND;

export const formatDate = (value: any, hour12: boolean = false) => {
  const options = {
    hour12,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  } as const;

  const date = new Date(value);
  return date.toLocaleString(undefined, options);
};

export const formatDay = (value: any) => {
  const options = {
    hour12: false,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  } as const;

  const date = new Date(value);
  return date.toLocaleString(undefined, options);
};

export const formatTime = (value: any) => {
  const options = {
    hour12: false,
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  } as const;

  const date = new Date(value);
  return date.toLocaleString(undefined, options);
};

export function formatTimestampUTC (timestamp: number | string): string {
  let numberTimestamp = Number(timestamp);

  // Convert to milliseconds if it's in seconds
  if (timestamp.toString().length === 10) {
    numberTimestamp *= 1000;
  }

  const date = new Date(numberTimestamp);

  // Format as YYYY-MM-DD HH:MM:SS UTC
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC`;
}
